import { createContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useHistory } from 'react-router-dom'
//Hooks
import usePrevious from '../hooks/usePrevious'

export const I18nContext = createContext({})

export function I18nContextProvider({ children }) {
    const { i18n, t } = useTranslation() //instance of i18next

    const location = useLocation()
    const history = useHistory()

    const [subPathLanguage, setSubPathLanguage] = useState(null)
    const [language, setLanguage] = useState(i18n.language)
    const [actualComponent, setActualComponent] = useState(null)
    const [param, setParam] = useState(null) //Para paginas que tengan parametro, subir el paramentro al contexto
    const previousLanguage = usePrevious(language)
    const previousComponent = usePrevious(actualComponent)

    useEffect(() => {
        setLanguage(i18n.language)
    }, [i18n.language])

    //Este path cambia por si solo cuando se cambia de lenguaje y/o de "pagina"
    let path = t(`routes.${actualComponent}`)

    useEffect(() => {
        if (path === 'routes.null') {
            return
        }
        /*
        A este punto ya sabemos que cambio o el lenguaje o el actualComponent
        */
        const { pathname, search } = location

        //Si el lenguaje cambia reemplazo la URL chequeando que si hay search incluirlo
        if (language !== previousLanguage) {
            // console.log('LANGUAGE CHANGED')
            // console.log({ param, search })

            // CONTIENE SEARCH Y PARAMS
            if (search && param) {
                history.replace(`/${language}${path}/${param}${search}`)
                return
            }
            // CONTIENE SOLO PARAMS
            if (!search && param) {
                history.replace(`/${language}${path}/${param}`)
                return
            }
            // CONTIENE SOLO SEARCH
            if (search && !param) {
                history.replace(`/${language}${path}${search}`)
                return
            }
            // Redireccionar a la nueva url
            history.replace(`/${language}${path}`)
            return
        }
        // Si no cambio el lenguaje y solo cambio el actualComponent (cambio de pagina)
        if (actualComponent !== previousComponent) {
            // console.log('ACTUAL COMPONENT CHANGED')

            const splitPath = pathname.split('/')

            //SI EL PATHNAME NO CONTIENE EL LENGUAJE ACTUAL QUIERE DECIR QUE SE CAMBIO DE LENGUAJE EN OTRA PAGINA
            if (!splitPath.includes(language)) {
                // CONTIENE SEARCH Y PARAMS
                if (search && param) {
                    history.replace(`/${language}${path}/${param}${search}`)
                    return
                }
                // CONTIENE SOLO PARAMS
                if (!search && param) {
                    history.replace(`/${language}${path}/${param}`)
                    return
                }
                // CONTIENE SOLO SEARCH
                if (search && !param) {
                    history.replace(`/${language}${path}${search}`)
                    return
                }
                // Redireccionar a la nueva url
                history.replace(`/${language}${path}`)
                return

                //Esto es en caso que se abra la pagina en localhost:3000/en/, le agregamos el nombre del path en la ruta
            } else if (splitPath.includes(language) && !splitPath.includes(path.slice(1))) {
                // history.replace(`/${language}${path}`)
                return
            }
        }
    }, [language, actualComponent]) //Cambio de pagina o lenguaje

    return (
        <I18nContext.Provider
            value={{
                setLanguage,
                language,
                actualComponent,
                setActualComponent,
                subPathLanguage,
                setSubPathLanguage,
                param,
                setParam,
                path,
            }}
        >
            {children}
        </I18nContext.Provider>
    )
}
